<template>
    <section class="test flow__panel">
        <scheme-select />

        <div class="test__container">
            <div class="test__label">
                Typography
            </div>
            <h1>Heading 1</h1>
            <h2>Heading 2</h2>
            <h3>Heading 3</h3>
            <h4>Heading 4</h4>
            <h5>Heading 5</h5>
            <h6>Heading 6</h6>
            <p>Lorem <a href="https://example.com">link which can be visited</a>, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim <a href="https://________.com">unvisited link</a> ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        </div>
        <div class="test__container">
            <div class="test__label">
                Buttons
            </div>
            <hh-btn text="Standard Button" />
            <hh-btn text="Disabled Button" disabled />
            <hh-btn type="cta" text="CTA Button" />
            <hh-btn type="cta-danger" text="CTA Danger Button" />
            <hh-btn type="cancel" text="Cancel Button" />
            <hh-btn text="Icon Button" icon-class="fas fa-save" />
        </div>
        <div class="test__container">
            <div class="test__label">
                CTA Tile Buttons
            </div>
            <cta-tile class="my-home__details__cta__tile cta-tile--branded"
                      name="build"
                      :button-text="ctaButtonText"
                      show-small-image
                      secondary-button-text="Edit"
                      icon-class="fas fa-chevron-circle-right"
                      icon-location="post"
                      type="cta"
                      breakout-extended />
        </div>
        <div class="test__container">
            <div class="test__label">
                Form Inputs
            </div>
            <hh-form>
                <hh-form-group def="checkbox" label-text="Checkbox">
                    <hh-checkbox def="checkbox" />
                </hh-form-group>
                <hh-form-group def="email" ref="email" label-text="Email">
                    <hh-email def="email" v-model="email" />
                    <hh-validator for="email" />
                    {{ email }}
                </hh-form-group>
                <hh-form-group def="number" label-text="Number">
                    <hh-number def="number" allow-decimal-point />
                </hh-form-group>
                <hh-form-group def="password" label-text="Password">
                    <hh-password def="password" />
                </hh-form-group>
                <hh-form-group label-text="Radio List">
                    <hh-radio def="radio" :options="options" v-model="radio" />
                    {{ radio }}
                </hh-form-group>
                <hh-form-group def="select" label-text="Select List">
                    <hh-select def="select" :options="options" v-model="list" />
                    {{ list }}
                </hh-form-group>
                <hh-form-group def="tel" label-text="Telephone">
                    <hh-tel def="tel" />
                </hh-form-group>
                <hh-form-group def="text" label-text="Text">
                    <hh-textbox def="text" v-model="text" />
                    {{ text }}
                </hh-form-group>
                <hh-form-group def="text-placeholder" label-text="Placeholder Text">
                    <hh-textbox def="text-placeholder" placeholder="Placeholder text" />
                </hh-form-group>
                <hh-form-group def="text-disabled" label-text="Disabled Text">
                    <hh-textbox def="text-disabled" disabled />
                </hh-form-group>
                <hh-form-group def="yesno" label-text="Yes / No">
                    <hh-yes-no def="yesno" />
                </hh-form-group>
            </hh-form>
        </div>
        <div class="test__container">
            <div class="test__label">
                Confidence
            </div>
            <hh-confidence
                v-for="confidence in 4"
                :key="confidence"
                :value="confidence" />
        </div>
        <div class="test__container">
            <div class="test__label">
                Message Display
            </div>
            <hh-msg-display type="affirm" message="Affirm message" />
            <hh-msg-display type="ok" message="OK message" />
            <hh-msg-display type="error" message="Error message" />
            <hh-msg-display type="warning" message="Warning message" />
            <hh-msg-display type="info" message="Info message" />
            <hh-msg-display type="default" message="Default message" />
        </div>
        <div class="test__container">
            <div class="test__label">
                Miscellaneous
            </div>
            <hh-waiting />
            <hh-tooltip text="Tooltip text"
                        position="top-left">
                This text has a tooltip
            </hh-tooltip>
            <hh-info-attachment title="Info Title"
                                text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                                image-url="/img/logo.png" />
        </div>
        <div class="test__container">
            <div class="test__label">
                Grouped Accordions
            </div>
            <p>Placing accordions together in an <code>hh-accordion-group</code> component allows only one to open at a time.</p>
            <hh-accordion-group>
                <hh-accordion-item v-for="tab in tabs" :key="tab.title" :title="tab.title">
                    <template #trigger>
                        <span :class="`fas ${tab.icon}`" />
                        {{ tab.title }}
                    </template>
                    <template>
                        <p>{{ tab.content }}</p>
                    </template>
                </hh-accordion-item>
            </hh-accordion-group>
        </div>
        <div class="test__container">
            <div class="test__label">
                Solo Accordions
            </div>
            <div class="test__gutter">
                <hh-accordion-item title="Accordion Solo One">
                    <template>
                        <p>Lorem ipsum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    </template>
                </hh-accordion-item>
            </div>
            <div class="test__gutter">
                <hh-accordion-item title="Accordion Solo Two" open>
                    <template>
                        <p>Lorem ipsum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                        <p>Lorem ipsum consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                    </template>
                </hh-accordion-item>
            </div>
        </div>
        <div class="test__container">
            <div class="test__label">
                Tabbed Panels
            </div>
            <hh-tab-group>
                <hh-tab-panel v-for="tab in tabs" :key="tab.title" :title="tab.title" :content="tab">
                    <p>{{ tab.content }}</p>
                </hh-tab-panel>
            </hh-tab-group>
        </div>
        <div class="test__container">
            <div class="test__label">
                Custom Tab
            </div>
            <hh-tab-group :active="active">
                <template v-slot:tab="slotProps">
                    <span :class="`fas ${slotProps.tab.content.icon}`" />
                    {{ slotProps.tab.title }}
                </template>
                <hh-tab-panel v-for="tab in tabs" :key="tab.title" :title="tab.title" :content="tab">
                    <p>{{ tab.content }}</p>
                </hh-tab-panel>
            </hh-tab-group>
            <p>Active tab can be set outside the component using the <code>active</code> property of the TabGroup.</p>
            <button @click="active='Home'">
                Home
            </button>
            <button @click="active='Account'">
                Account
            </button>
        </div>
        <div class="test__container">
            <div class="test__label">
                Segment Icons in Tabs
            </div>
            <hh-tab-group class="my-home-edit__tab-group">
                <template v-slot:tab="slotProps">
                    <span class="my-home-edit__tab--title">
                        {{ slotProps.tab.content.text }}
                    </span>
                    <segment-icon :segment-key="slotProps.tab.content.key"
                                  class="my-home-edit__tab--icon" />
                </template>
                <hh-tab-panel v-for="segment in segmentMaps"
                              :key="segment.key"
                              class="my-home-edit__tab-panel"
                              :content="segment"
                              :title="segment.text">
                    <h1>{{ segment.text }}</h1>
                </hh-tab-panel>
            </hh-tab-group>
        </div>
        <div class="test__container">
            <div class="test__label">
                Segment Icons
            </div>
            <section class="property-summary">
                <ul class="property-summary__segments">
                    <summary-segment-item v-for="segment in $scheme.segmentKeymap"
                                          class="property-summary__segments__item"
                                          :key="segment.key"
                                          :segment="segment" />
                </ul>
            </section>
        </div>
        <div class="test__container">
            <div class="test__label">
                Accent Panels
            </div>
            <hh-accent-panel>
                <p>Accent panel with some simple text content.</p>
            </hh-accent-panel>
            <attributions-panel />
        </div>
        <responsive-view />
    </section>
</template>
<script>

import AttributionsPanel from '@/components/app-core/attributions-panel'
import CtaTile from '@/components/app-core/cta-tile'
import ResourcesHelper from '@/components/resources-helper'
import ResponsiveView from '@/components/dev/responsive-view'
import SchemeSelect from '@/components/dev/scheme-select'
import SegmentIcon from '@/components/my-home/segment-icon'
import SummarySegmentItem from '@/components/my-home/summary-segment-item'

export default {
    mixins: [
        ResourcesHelper,
    ],

    data() {
        return {
            email: '',
            text: '',
            radio: '',
            list: '',
            active: 'Account',
        }
    },

    computed: {
        segmentMaps() {
            return this.$scheme.segmentKeymap
        },

        options() {
            return [
                {
                    key: 'monday-key',
                    text: 'Monday',
                    value: 'monday',
                },
                {
                    key: 'tuesday-key',
                    text: 'Tuesday',
                    value: 'tuesday',
                },
                {
                    key: 'wednesday-key',
                    text: 'Wednesday',
                    value: 'wednesday',
                },
                {
                    key: 'thursday-key',
                    text: 'Thursday',
                    value: 'thursday',
                },
                {
                    key: 'friday-key',
                    text: 'Friday',
                    value: 'friday',
                },
                {
                    key: 'saturday-key',
                    text: 'Saturday',
                    value: 'saturday',
                },
                {
                    key: 'sunday-key',
                    text: 'Sunday',
                    value: 'sunday',
                },
            ]
        },

        tabs() {
            return [
                {
                    title: 'Home',
                    icon: 'fa-house',
                    content: 'Home tab content. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Proin metus nisl, vulputate a bibendum ut, bibendum mattis nunc. Vivamus varius tempor metus, fringilla vulputate enim vehicula id. Donec eu faucibus mauris. Morbi feugiat bibendum libero sed luctus. Ut ullamcorper odio et venenatis ultrices. Ut congue dolor mauris, quis lobortis libero pharetra nec. Nam venenatis bibendum justo eu aliquet. Praesent tempor vehicula purus, quis faucibus quam dignissim quis. Vivamus ut commodo magna.',
                },
                {
                    title: 'Account',
                    icon: 'fa-user',
                    content: 'Account tab content. Nullam lacinia neque nec est interdum finibus id vel felis. Integer eleifend nibh ac mauris facilisis, in aliquam sapien scelerisque. Vivamus bibendum non diam vitae aliquet. Maecenas nec nunc tristique, mollis libero ac, bibendum tellus. Morbi mollis elit varius sapien luctus volutpat. Quisque ac dapibus lacus. Aenean mauris nisl, gravida id lacus id, congue sagittis turpis.',
                },
                {
                    title: 'Favourites',
                    icon: 'fa-heart',
                    content: 'Favourites tab content. Etiam sodales sagittis efficitur. Nunc nec ultricies nulla. Vivamus aliquet magna a justo rhoncus, bibendum pellentesque magna commodo. Vivamus sed interdum lorem, vel fringilla lorem. Aenean nulla tortor, porttitor nec convallis ut, sagittis eu sem. Nam auctor arcu ultrices mauris iaculis eleifend. Proin ut ullamcorper lectus. Donec at porta nisl. Sed eu semper massa. Cras vitae pulvinar diam. Aenean aliquam est sit amet mauris fringilla vestibulum.',
                },
            ]
        },

        ctaButtonText() {
            const overrideText = this.allResources.views.myHome.ctaBuildPlan || null
            return overrideText
                ? overrideText
                : `Build your ${ this.$scheme.shortTitle } plan`
        },
    },

    components: {
        AttributionsPanel,
        CtaTile,
        ResponsiveView,
        SchemeSelect,
        SegmentIcon,
        SummarySegmentItem,
    },
}

</script>
<style lang="scss">

.test__label {
  text-transform: uppercase;
  color: rgb(70,70,70);
  font-size: 7pt;
  margin: 0.7rem 0;
}
.test__container {
  position: relative;
  margin-top: 2rem;
  padding-top: 1rem 0;
  border-top: 1px solid rgb(120,120,120);

  &:first-of-type {
    border-top: 0;
  }
}
.test__gutter {
  margin-bottom: 20px;
}

</style>
